<template>
  <TrainerLayout :isContained="false">
    <section class="mt-2">
      <section class="mb-10">
        <div class="flex flex-col sm:flex-row justify-between bg-smokeWhite w-full rounded-lg px-6 py-6 mb-4 shadow-lg-2"
          v-if="!verified"
        >
          <div class="flex items-center">
            <div class="bg-black rounded-md">
              <img
                :src="require(`@/assets/img/email.png`)"
                class="md:w-12 w-auto"
                alt="email.png"
              />
            </div>
            <div class="flex flex-col ml-5">
              <span class="font-semibold text-2xl text-blacklight">
                Confirm your email address to activate your account
              </span>
              <span class="text-base font-normal text-blacklight">
                Once your email is confirmed you can host classes and earn money
              </span>
            </div>
          </div>
          <button
            class="w-52 text-white bg-blacklight px-6 py-4 text-xl rounded-lg font-semibold mt-4 md:mt-0"
            @click="onclickResendEmail"
          >
            <!-- Confirm -->
            Resend Email
          </button>
        </div>
        <div class="flex flex-col sm:flex-row justify-between bg-smokeWhite w-full rounded-lg px-6 py-6 mb-4 shadow-lg-2"
          v-if="!zoomAuthorized">
          <div class="flex items-center">
            <div class="bg-blue-royal rounded-md">
              <img
                :src="require(`@/assets/svg/Zoom.svg`)"
                class="md:w-12 w-auto"
                alt="Zoom.svg"
              />
            </div>
            <div class="flex flex-col ml-5">
              <span class="font-semibold text-2xl text-blacklight">
                Setup your Zoom Account to run live classes
              </span>
              <span class="text-base font-normal text-blacklight">
                Once Zoom has been connected you can create live classes and
                courses
              </span>
            </div>
          </div>
          <div class="flex flex-col mt-4 sm:mt-0">
            <a
              class="mt-4 md:mt-0 w-52 text-white bg-blacklight px-6 py-4 text-xl rounded-lg font-semibold"
              :href="
                'https://zoom.us/oauth/authorize?response_type=code&client_id=' +
                VUE_APP_ZOOMOAUTH_CLIENT_ID +
                '&redirect_uri=' +
                VUE_APP_APP_URL +
                'dashboard'
              "
            >
              Connect Zoom
            </a>
            <p class="text-xs pt-1">
              Don't have Zoom account?
              <a
                href="https://zoom.us/signup"
                target="_blank"
                class="text-blue-600"
                >Create</a
              >
            </p>
          </div>
        </div>
        <div class="flex flex-col sm:flex-row justify-between bg-smokeWhite w-full rounded-lg px-6 py-6 mb-4 shadow-lg-2"
          v-if="!stripeConnected">
          <div class="flex items-center mb-4 sm:mb-0">
            <div class="bg-green-light rounded-md w-12 flex items-center">
              <img
                :src="require(`@/assets/svg/Money.svg`)"
                class="md:w-12 w-auto"
                alt="Money.svg"
              />
            </div>
            <div class="flex flex-col ml-5">
              <span class="font-semibold text-2xl text-blacklight">
                Set up payment gateways to get paid
              </span>
              <span class="text-base font-normal text-blacklight">
                Once you set up your payment gateway you can charge your
                attendees
              </span>
            </div>
          </div>
          <button
            class="mt-4 md:mt-0 w-52 text-white bg-blacklight px-6 py-4 text-xl rounded-lg font-semibold"
            @click="onclickSetupPayments"
          >
            Set up payment
          </button>
        </div>
        <div
          v-if="!googleConnected"
          class="flex flex-col sm:flex-row justify-between bg-smokeWhite w-full rounded-lg px-6 py-6 shadow-lg-2"
        >
          <div class="flex items-center mb-4 sm:mb-0">
            <div class="bg-white h-12 rounded-md w-12 flex items-center justify-center">
              <GoogleIcon />
            </div>
            <div class="flex flex-col ml-5">
              <span class="font-semibold text-2xl text-blacklight">
                Set up Google calendar to sync Classes
              </span>
              <span class="text-base font-normal text-blacklight">
                Once you set up your Google calendar you can sync your Classes
              </span>
            </div>
          </div>
          <button
            class="mt-4 md:mt-0 w-52 text-white bg-blacklight px-6 py-4 text-xl rounded-lg font-semibold"
            @click="onClickGoogleSync"
          >
            Connect Google
          </button>
        </div>
      </section>

      <section class="mb-8">
        <div class="flex flex-col sm:flex-row">
          <router-link
            class="m-w-200 p-3 ring-1 ring-gray-300 rounded-2xl hover:shadow-md flex items-center justify-between"
            :to="{ name: 'createSession' }"
          >
            <p class="font-medium">Add Class</p>
            <img
              :src="require(`@/assets/img/GreenPlus.png`)"
              alt=""
              class="w-8"
            />
          </router-link>
          <router-link
            :to="{ name: 'createCourse' }"
            class="m-w-200 p-3 ring-1 ring-gray-300 rounded-2xl hover:shadow-md flex items-center justify-between sm:ml-4 ml-0 mt-4 sm:mt-0"
          >
            <p class="font-medium">Add Class Pack</p>
            <img
              :src="require(`@/assets/img/GreenPlus.png`)"
              alt=""
              class="w-8"
            />
          </router-link>
        </div>
      </section>

      <section class="mb-12">
        <div class="flex justify-between items-baseline mb-6">
          <h6 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">My Earnings</h6>
          <!-- <select
            name="days"
            id="days"
            class="pr-20 pl-4 mt-4 dropdown py-3 text-sm font-normal ring-1 bg-white ring-gray-400 focus:outline-none rounded-md appearance-none"
          >
            <option value="30">Last 30 days</option>
            <option value="30">Last 6 months</option>
            <option value="30">Last 1 year</option>
          </select> -->
          <!-- <Dropdown
            v-model="selectedDate"
            :options="dates"
            placeholder="Select a date"
            dropdownStyle="w-40"
            v-on:selected-option="handleDropdownSelect"
          /> -->
        </div>
        <div class="xl:flex mt-4 md:space-x-4">
          <div class="grid md:grid-cols-3 grid-cols-1 xl:gap-6 gap-4 w-full">
            <div class="shadow-lg-2 hover:shadow-lg rounded-lg border-1 border-borderColor h-44 bg-white py-3 pl-5 pr-8 flex flex-col justify-between">
              <div class="flex items-center">
                <img
                  :src="require(`@/assets/img/Earning.png`)"
                  alt="earning"
                  class="p-3 h-10 bg-smokeWhite rounded-lg"
                />
                <p
                  class="text-sm sm:text-md capitalize font-medium leading-normal ml-4"
                >
                  Total year's earnings
                </p>
              </div>
              <div class="flex items-end justify-between mt-6">
                <h3 class="text-3xl font-semibold leading-normal mt-8">
                  <!-- trainerYearlyEarnings.lastYearEarning -->
                  $
                  {{
                    trainerYearlyEarnings &&
                    trainerYearlyEarnings.thisYearEarning &&
                    trainerYearlyEarnings.thisYearEarning.currentYearEarning
                  }}
                </h3>
              </div>
            </div>
            <div class="shadow-lg-2 hover:shadow-lg rounded-lg border-1 border-borderColor h-44 bg-white py-3 pl-5 pr-8 flex flex-col justify-between">
              <div class="flex items-center">
                <img
                  :src="require(`@/assets/img/Earning.png`)"
                  alt="earning"
                  class="p-3 h-10 bg-smokeWhite rounded-lg"
                />
                <p
                  class="text-sm md:text-md capitalize font-medium leading-normal ml-4"
                >
                  This month's earnings
                </p>
              </div>
              <div class="flex items-end justify-between mt-6">
                <h3
                  class="text-3xl sm:text-3xl font-semibold leading-normal mt-8"
                >
                  $
                  {{
                    trainerYearlyEarnings &&
                    trainerYearlyEarnings.thisYearEarning &&
                    trainerYearlyEarnings.thisYearEarning.currentMonthEarning
                  }}
                </h3>
                <div>
                  <div class="flex">
                    <img
                      :src="require(`@/assets/img/arrow-up.png`)"
                      alt="arrow"
                      class="mb-1"
                    />
                    <p class="text-green-light">
                      {{
                        trainerYearlyEarnings &&
                        trainerYearlyEarnings.thisYearEarning &&
                        trainerYearlyEarnings.thisYearEarning
                          .currentWeekEarningPercentage
                      }}
                      %
                    </p>
                  </div>
                  <p class="text-sm">This week</p>
                </div>
              </div>
            </div>
            <div class="shadow-lg-2 hover:shadow-lg rounded-lg border-1 border-borderColor h-44 bg-white py-3 pl-5 pr-8 flex flex-col justify-between">
              <div class="flex items-center">
                <img
                  :src="require(`@/assets/img/Earning-breakdown.png`)"
                  alt="earning"
                  class="p-3 h-10 bg-smokeWhite rounded-lg"
                />
                <p
                  class="text-sm sm:text-md capitalize font-medium leading-normal ml-4"
                >
                  Earnings Breakdown
                </p>
              </div>
              <div class="mt-8">
                <div class="flex justify-between items-center">
                  <p class="min-w-16 text-sm">Classes</p>
                  <div
                    class="w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-700"
                  >
                    <div
                      class="bg-green-light h-1.5 rounded-full"
                      :style="{
                        width:
                          (trainerYearlyEarnings &&
                            trainerYearlyEarnings.earningBreakdown &&
                            trainerYearlyEarnings.earningBreakdown
                              .classPercentage) ||
                          0,
                      }"
                    ></div>
                  </div>
                  <div class="text-sm text-gray-700 ml-4">
                    {{
                      (trainerYearlyEarnings &&
                        trainerYearlyEarnings.earningBreakdown &&
                        trainerYearlyEarnings.earningBreakdown
                          .classPercentage) ||
                      0
                    }}%
                  </div>
                </div>

                <div class="flex justify-between items-center">
                  <p class="min-w-16 text-sm">Class Packs</p>
                  <div
                    class="w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-700"
                  >
                    <div
                      class="bg-green-light h-1.5 rounded-full"
                      :style="{
                        width:
                          (trainerYearlyEarnings &&
                            trainerYearlyEarnings.earningBreakdown &&
                            trainerYearlyEarnings.earningBreakdown
                              .coursePercentage) ||
                          0,
                      }"
                    ></div>
                  </div>
                  <div class="text-sm text-gray-700 ml-4">
                    {{
                      (trainerYearlyEarnings &&
                        trainerYearlyEarnings.earningBreakdown &&
                        trainerYearlyEarnings.earningBreakdown
                          .coursePercentage) ||
                      0
                    }}%
                  </div>
                </div>

                <!-- <div class="flex justify-between items-center">
                  <p class="min-w-16 text-sm">Private</p>
                  <div
                    class="w-full bg-gray-200 rounded-full h-1.5 dark:bg-gray-700"
                  >
                    <div
                      class="bg-green-light h-1.5 rounded-full"
                      style="width: 0%"
                    ></div>
                  </div>
                  <div class="text-sm text-gray-700 ml-4">0%</div>
                </div> -->
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="mb-10">
        <div>
          <!-- <h6 class="text-2xl font-semibold mb-4">My Upcoming Classes</h6> -->
          <div class="mb-6 flex justify-between items-center">
            <div class="">
              <h6 class="md:text-3xl text-xl font-semibold leading-normal mt-0 text-blacklight">
                My Upcoming Classes
              </h6>
            </div>
            <router-link :to="{ name: 'SessionUpcoming' }">
              <button
                class="inline-flex items-center h-8 px-1 text-sm transition-colors duration-150 ring-1 text-white rounded-md focus:outline-none bg-green-light hover:text-green-light hover:bg-white ring-green-light"
              >
                <span class="px-1 whitespace-nowrap">See all</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  class="h-6 w-6"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M13 7l5 5m0 0l-5 5m5-5H6"
                  />
                </svg>
              </button>
            </router-link>
          </div>
          <MySessionsCard
            :data="
              trainerUpcomingSessions &&
              trainerUpcomingSessions.data &&
              trainerUpcomingSessions.data.data
            "
            :statusCode="
              trainerUpcomingSessions && trainerUpcomingSessions.statusCode
            "
          />
        </div>
      </section>
      <UpdateTimeZoneModal></UpdateTimeZoneModal>
    </section>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout";
import MySessionsCard from "@/components/MySessionsCard";
import LineChart from "@/components/chart/LineChart.vue";
import { mapGetters, mapActions } from "vuex";
import { GoogleIcon } from "@/components/icons";
import { UpdateTimeZoneModal } from "@/components/t-components";
// import Dropdown from "../../../src/components/t-components/Dropdown";

export default {
  name: "Dashboard",
  components: {
    TrainerLayout,
    MySessionsCard,
    LineChart,
    GoogleIcon,
    UpdateTimeZoneModal
    // Dropdown,
  },
  data() {
    return {
      currentPage: 1,
      per_page: 8,
      details: JSON.parse(localStorage.getItem("details")),
      redirectUri: window.config.VUE_APP_APP_URL + "dashboard",
      zoomAuthorized: true,
      stripeConnected: true,
      verified: true,
      googleConnected: true,
      // dates: [
      //   {
      //     title: "Last 30 days",
      //     value: 1,
      //   },
      //   {
      //     title: "Last 6 months",
      //     value: 2,
      //   },
      //   {
      //     title: "Last 1 year",
      //     value: 3,
      //   },
      // ],
      // selectedDate: [],
    };
  },
  computed: {
    ...mapGetters([
      "trainerUpcomingSessions",
      "trainerStripeUrl",
      "trainerProfileDetails",
      "trainerYearlyEarnings",
      "syncStatus"
    ]),
  },
  methods: {
    ...mapActions([
      "getTrainerUpcomingSessions",
      "postTrainerZoomAuthentication",
      "postTrainerStripeConnect",
      "getTrainerStripeUrl",
      "getTrainerProfileDetails",
      "getTrainerYearlyEarnings",
      "resendVerificationEmail",
    ]),

    async onclickSetupPayments() {
      await this.getTrainerStripeUrl();
      window.open(this.trainerStripeUrl);
    },

    // handleDropdownSelect(value) {
    //   console.log(value);
    // },

    onclickResendEmail() {
      const data = {
        // email: this.getUser() && this.getUser().email,
        id: this.getUser() && this.getUser().id,
      };
      // this.resetPassword(data);
      this.resendVerificationEmail(data);
    },
    async onClickGoogleSync() {
      const client = await google.accounts.oauth2.initCodeClient({
        client_id: window.config.VUE_APP_GOOGLE_CLIENT_ID,
        scope: "profile email https://www.googleapis.com/auth/calendar",
        ux_mode: "popup",
        callback: (response) => {
          this.$store.dispatch('postOauth', { code: response.code }).then(() => {
            this.googleConnected = true
            // this.$store.dispatch('getSyncStatus')
          });
        },
      });
      client && client.requestCode();
    },
  },
  async created() {
    const obj_length = Object.keys(this.$route.query).length;
    if (obj_length > 0) {
      let data = {
        code: this.$route.query.code,
        redirect_uri: this.redirectUri,
      };
      if (this.$route.query.scope) {
        this.$store.commit('setIsLoading', true)
        await this.postTrainerStripeConnect(this.$route.query.code);
        this.stripeConnected = !this.stripeConnected;
      } else {
        this.$store.commit('setIsLoading', true)
        await this.postTrainerZoomAuthentication(data);
        // this.zoomAuthorized = !this.zoomAuthorized;
        this.$router.push({ name: "dashboard" });
      }
    }
    const query = {
      per_page: this.per_page,
      page: this.currentPage,
    };
    await this.getTrainerUpcomingSessions({ query });
    await this.getTrainerProfileDetails();
    this.zoomAuthorized =
      this.trainerProfileDetails && this.trainerProfileDetails.zoomAuthorized;
    this.stripeConnected =
      this.trainerProfileDetails && this.trainerProfileDetails.stripeConnected;
    this.verified =
      this.trainerProfileDetails && this.trainerProfileDetails.verified;
    await this.$store.dispatch('getSyncStatus');
    await this.getTrainerYearlyEarnings();
  },
  watch: {
    syncStatus () {
      this.syncStatus && this.syncStatus.is_synced ? this.googleConnected = true : this.googleConnected = false
    }
  }
};
</script>

<style scoped>
.shadow-lg-2 {
  box-shadow: 20px 20px 40px rgba(22, 29, 37, 0.05);
}
.m-w-200{
  min-width: 200px;
}
</style>